var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMavi(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 187,
    height: 64,
    viewBox: "0 0 187 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_238_1681)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 62.5435H17.3289V37.9302C17.3289 33.1987 18.8173 29.7882 23.1939 29.7882C28.4477 29.7882 28.8814 33.6423 28.8814 37.9302V62.5435H46.2103V37.9302C46.2103 33.1987 47.6987 29.7882 52.0753 29.7882C57.3292 29.7882 57.7629 33.6423 57.7629 37.9302V62.5435H75.0918V31.3653C75.0918 24.002 71.1489 15.9487 59.5076 15.9487C47.8663 15.9487 44.7219 22.5136 44.0122 23.0459C41.9126 18.4919 36.6587 15.9487 31.7597 15.9487C25.461 15.9487 20.3846 17.8709 16.8853 23.1346H16.7079V17.0922H0V62.5533V62.5435Z",
    fill: "#1C75BC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.309 46.3384C106.053 51.0698 102.987 53.4356 99.0446 53.4356C95.8903 53.4356 93.6232 51.336 93.6232 49.2364C93.6232 46.1708 95.634 45.2048 99.4882 44.3276C101.854 43.8051 104.21 43.194 106.309 42.1393V46.3384ZM122.938 33.7213C122.938 24.9583 123.116 15.939 101.4 15.939C90.6365 15.939 78.5615 18.0385 78.0292 30.8331H94.1358C94.2245 28.9011 95.2693 26.1904 100.612 26.1904C103.411 26.1904 106.299 27.3338 106.299 30.3994C106.299 33.2875 103.944 33.9874 101.578 34.431C92.736 36.0968 75.9395 35.5744 75.9395 49.9363C75.9395 59.4879 83.2042 63.687 91.9573 63.687C97.5562 63.687 102.899 62.4647 106.575 58.2557H106.743C106.654 59.4879 106.92 61.3213 107.354 62.5534H125.038C123.116 59.6653 122.938 55.8111 122.938 52.3907V33.741V33.7213Z",
    fill: "#1C75BC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M171.199 17.0825H153.525L146.349 44.7614H146.172L139.084 17.0825H120.79L135.674 62.5437H156.147L171.199 17.0825Z",
    fill: "#1C75BC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M169.671 62.5436H187V17.0824H169.671V62.5436ZM187 0H169.671V12.1736H187V0Z",
    fill: "#1C75BC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_238_1681"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 187,
    height: 63.6772,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMavi);
export default __webpack_public_path__ + "static/media/Mavi.3ad80f19d96155b9e3695275aac89776.svg";
export { ForwardRef as ReactComponent };